import { render, staticRenderFns } from "./QuoteTable.vue?vue&type=template&id=f4c23180&"
import script from "./QuoteTable.vue?vue&type=script&lang=js&"
export * from "./QuoteTable.vue?vue&type=script&lang=js&"
import style0 from "./QuoteTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports